/** 上线产品 pid（clientVer 前两位）；暂不含 gemoji */
export const ProductOptions = [
  { code: 11, name: 'Avatar Android', short: '11' },
  { code: 12, name: 'Avatar iOS', short: '12' },
  { code: 16, name: 'OC Avatar', short: '16' },
]

/**
 * 提审进 draft 时默认全选。
 * 展示语义：缺省/空 = 未上任何产品（不是全产品）。
 */
export const DEFAULT_PRODUCT_IDS = ProductOptions.map((p) => p.code)
